<!-- <div class="nav-button">
    <button mat-raised-button color="primary" [routerLink]="[dispositionGroupUrl]">Group Management</button>
</div> -->
<h2 class="page-heading">Disposition</h2>

<mat-tab-group>

    <mat-tab label="Dispositions">
        <app-response-text
            [lambdaMessage]="lambdaMessage"
            [lambdaError]="lambdaError">
        </app-response-text>
        <div class="table-container">

            <!--hide this element from LOBAdmins. Telecom only-->
            <div class="filter-select" *ngIf="isTelecom">
                <select class="custom-select table-select" [(ngModel)]="lobSelect" (ngModelChange)="selectChange();">
                    <option class="custom-option" ngValue="DEFAULT" selected>Select LOB</option>
                    <option class="custom-option" *ngFor = "let lob of lobList" [ngValue]="lob[1]">{{lob[0]}}</option>
                </select>
            </div>
            <div *ngIf="lobSelect != 'DEFAULT'">
                <select class="custom-select table-select" *ngIf="lobSelect != 'DEFAULT'" [(ngModel)]="dispositionGroupSelect" (ngModelChange)="selectChange();">
                    <option class="custom-option" ngValue="DEFAULT" >Default Group</option>
                    <option class="custom-option" *ngFor="let dispositionGroup of filteredDispositionGroups" [ngValue]="dispositionGroup.groupId">{{dispositionGroup.groupName}}</option>
                </select>
            </div>

            <!--messages table-->
            <div *ngIf="lobSelect != 'DEFAULT'">

                <app-mat-data-grid
                    class="page-data-grid"
                    [formValid]="formValid"
                    [(dataSource)]="filteredData"
                    [headerTwo]="message"
                    [displayedColumns]="['code', 'disposition.text', 'disposition.description', 'disposition.status', 'callType']"
                    [columnNames]="['Code', 'Disposition', 'Description', 'Status', 'Call Type']"
                    [editDefinition]="{
                        'disposition.text': text,
                        'disposition.description': description,
                        'disposition.status': status,
                        'callType': callType
                    }"
                    [pageSizeOptions]="[5, 10, 25, 50]"
                    [buttonConfig]="{
                        delete: { show: false },
                        create: { show: true }
                    }"
                    [objectBluePrint]="bluePrint"
                    (buttonClick)="handleDispositionButton($event)"
                >
                    <ng-template #message>
                        <app-response-text
                            [lambdaMessage]="lambdaMessage"
                            [lambdaError]="lambdaError">
                        </app-response-text>
                    </ng-template>

                    <ng-template let-element #text>
                        <input type="text" [(ngModel)]="element.disposition.text" (ngModelChange)="validate(element);">
                    </ng-template>

                    <ng-template let-element #description>
                        <input type="text" [(ngModel)]="element.disposition.description" (ngModelChange)="validate(element);">
                    </ng-template>

                    <ng-template let-element #status>
                        <select class="custom-select" [(ngModel)]="element.disposition.status" (ngModelChange)="validate(element);">
                            <option class="custom-option" value="Enabled">Enabled</option>
                            <option class="custom-option" value="Disabled">Disabled</option>
                        </select>
                    </ng-template>

                    <ng-template let-element #callType>
                        <select class="custom-select" [(ngModel)]="element.callType" (ngModelChange)="validate(element);">
                            <option class="custom-option" value="INBOUND">Inbound</option>
                            <option class="custom-option" value="OUTBOUND">Outbound</option>
                            <option class="custom-option" value="BOTH" selected>Both</option>
                        </select>
                    </ng-template>
                </app-mat-data-grid>

            </div>
        </div>
    </mat-tab>

    <mat-tab label="Groups">
        <app-disposition-group-management [(lob)]="lobSelect" (lobChange)="selectChange()"></app-disposition-group-management>
    </mat-tab>

</mat-tab-group>